import axios from 'axios'
import { store } from '../../store'
import { logoutUser } from '../../store/slices/authSlice'
import { handleApiError } from '../../utils/errorHandler'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 second timeout
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const apiError = handleApiError(error)
    
    // Handle authentication errors (401 Unauthorized or 480 Invalid Token)
    if (error.response?.status === 401 || error.response?.status === 480) {
      store.dispatch(logoutUser())
      window.location.href = '/login'
      return Promise.reject(apiError)
    }
    
    return Promise.reject(apiError)
  }
)

export default apiClient
